// @ts-nocheck
window.newsletterActions = window.newsletterActions || {
  activePopups: new Set(),
  initPopup: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    if (!popup || this.activePopups.has(sectionId)) return;

    // Respect subscription status
    if (localStorage.getItem('popup_subscribed_' + sectionId) === 'true') {
      this.hidePopupAndBar(sectionId);
      return;
    }

    var popupDismissed = localStorage.getItem('popup_dismissed_' + sectionId);
    var barDismissed = localStorage.getItem('bar_dismissed_' + sectionId);
    var bar = document.getElementById('newsletter-floating-bar-' + sectionId);

    // Attach core event listeners
    this.attachEventListeners(popup, sectionId);

    // Attach real-time validation
    this.attachValidationListeners(sectionId);

    // Mark popup form on submit
    this.attachSubmitMarker(popup, sectionId);

    if (!popupDismissed && !sessionStorage.getItem('popup_closed_once_' + sectionId)) {
      this.showPopup(popup, sectionId);
    } else if (!barDismissed && bar && !sessionStorage.getItem('popup_closed_once_' + sectionId)) {
      bar.style.display = 'flex';
    }


    this.activePopups.add(sectionId);
  },

  attachEventListeners: function (popup, sectionId) {
    // Close on overlay click
    popup.addEventListener('mousedown', function (e) {
      // Close if click happens outside modal container
      if (!e.target.closest('.newsletter-popup-modal')) {
        window.newsletterActions.closePopup(sectionId);
      }
    });


    // Close on close button click
    var closeButton = popup.querySelector('.newsletter-popup-close');
    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        window.newsletterActions.closePopup(sectionId);
      });
    }
  },

  // Attach real-time email validation
  attachValidationListeners: function (sectionId) {
    var emailInput = this.getEmailInput(sectionId);
    if (!emailInput) return;

    var self = this;
    emailInput.addEventListener('input', function () {
      self.validateEmail(sectionId);
    });
    emailInput.addEventListener('blur', function () {
      self.validateEmail(sectionId);
    });
  },

  // Mark popup form as submitted in sessionStorage
  attachSubmitMarker: function (popup, sectionId) {
    if (!popup || !sectionId) return;
    var form = popup.querySelector('.newsletter-form[data-section-id="' + sectionId + '"]');
    if (!form || form.dataset.popupMarkerAttached === 'true') return;

    form.addEventListener('submit', function () {
      try {
        sessionStorage.setItem('popup_submitted_' + sectionId, 'true');
      } catch (e) { }
    });

    form.dataset.popupMarkerAttached = 'true';
  },

  getEmailInput: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    return popup ? popup.querySelector('[name="contact[email]"]') : null;
  },

  getSubmitButton: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    return popup ? popup.querySelector('button[type="submit"]') : null;
  },

  getErrorElement: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    if (!popup) return null;

    var errorEl = popup.querySelector('.newsletter-error');
    if (!errorEl) {
      // create dynamically from form data-attributes or settings
      var form = popup.querySelector('.newsletter-form');
      if (!form) return null;

      errorEl = document.createElement('div');
      errorEl.className = 'newsletter-error';
      errorEl.style.color = form.dataset.errorColor || '#D82C0D';
      errorEl.style.display = 'none';
      errorEl.textContent = form.dataset.errorMessage || 'Please enter a valid email.';

      form.appendChild(errorEl);
    }

    return errorEl;
  },

  isValidEmail: function (email) {
    if (!email) return false;
    var re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})*$/;
    return re.test(email.trim());
  },

  // Validate and update UI
  validateEmail: function (sectionId) {
    var emailInput = this.getEmailInput(sectionId);
    var button = this.getSubmitButton(sectionId);
    var errorEl = this.getErrorElement(sectionId);

    if (!emailInput || !button) return;

    var email = emailInput.value;
    var isEmpty = email.trim() === '';
    var isValid = isEmpty || this.isValidEmail(email);

    // Get custom error message from form data attribute
    var form = document.querySelector('.newsletter-form[data-section-id="' + sectionId + '"]');
    var errorMessage = form && form.dataset.errorMessage
      ? form.dataset.errorMessage
      : 'Please enter a valid email address.';

    if (!isValid && !isEmpty) {
      // Show error
      if (errorEl) {
        errorEl.textContent = errorMessage;
        errorEl.style.display = 'block';
      }
      button.disabled = true;
      emailInput.classList.add('input-error');
    } else {
      // Hide error
      if (errorEl) errorEl.style.display = 'none';
      button.disabled = false;
      emailInput.classList.remove('input-error');
    }
  },

  showPopup: function (popup, sectionId) {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  },

  closePopup: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    if (popup) {
      popup.style.display = 'none';
      document.body.style.overflow = '';
      localStorage.setItem('popup_dismissed_' + sectionId, 'true');
      sessionStorage.setItem('popup_closed_once_' + sectionId, 'true');
    }

    var bar = document.getElementById('newsletter-floating-bar-' + sectionId);
    if (bar && localStorage.getItem('bar_dismissed_' + sectionId) !== 'true') {
      bar.style.display = 'flex';
    }
  },

  hidePopupAndBar: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    var bar = document.getElementById('newsletter-floating-bar-' + sectionId);
    if (popup) popup.style.display = 'none';
    if (bar) bar.style.display = 'none';
    document.body.style.overflow = '';
  },

  markSubscribed: function (sectionId) {
    localStorage.setItem('popup_subscribed_' + sectionId, 'true');
    this.hidePopupAndBar(sectionId);
  },

  reopenPopup: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    var bar = document.getElementById('newsletter-floating-bar-' + sectionId);
    if (popup) {
      this.showPopup(popup, sectionId);
    }
    if (bar) bar.style.display = 'none';
  },

  showSuccessOnLoad: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    if (!popup) return;

    if (sessionStorage.getItem('popup_success_shown_' + sectionId)) return;

    this.showPopup(popup, sectionId);

    var successEl = popup.querySelector('.newsletter-success');
    var errorEl = popup.querySelector('.newsletter-error');
    if (successEl) successEl.style.display = 'block';
    if (errorEl) errorEl.style.display = 'none';

    localStorage.setItem('popup_subscribed_' + sectionId, 'true');
    sessionStorage.setItem('popup_success_shown_' + sectionId, 'true');

    // ✅ CLEAN THE URL — remove query params & hash
    if (window.history && window.history.replaceState) {
      var cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState(null, document.title, cleanUrl);
    }

    setTimeout(() => {
      this.closePopup(sectionId);
      var bar = document.getElementById('newsletter-floating-bar-' + sectionId);
      if (bar) bar.style.display = 'none';
    }, 3000);
  },

  showErrorOnLoad: function (sectionId) {
    var popup = document.getElementById('newsletter-popup-' + sectionId);
    if (!popup) return;

    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    var errorEl = popup.querySelector('.newsletter-error');
    var successEl = popup.querySelector('.newsletter-success');
    if (errorEl) errorEl.style.display = 'block';
    if (successEl) successEl.style.display = 'none';

    var emailInput = this.getEmailInput(sectionId);
    if (emailInput) {
      emailInput.focus();
      if (emailInput.value) emailInput.select();
    }

    // Also run validation to disable button if still invalid
    this.validateEmail(sectionId);
  },

  dismissBar: function (sectionId) {
    var bar = document.getElementById('newsletter-floating-bar-' + sectionId);
    if (bar) {
      bar.style.display = 'none';
      localStorage.setItem('bar_dismissed_' + sectionId, 'true');
    }
  }
};

// Reinitialize on Shopify AJAX navigation
document.addEventListener('shopify:section:load', function (e) {
  var sectionId = e.detail.sectionId;
  var section = document.querySelector('[data-section-id="' + sectionId + '"]');
  if (section && section.querySelector('.newsletter-popup-overlay')) {
    window.newsletterActions.activePopups.delete(sectionId);
    window.newsletterActions.initPopup(sectionId);
  }
});

// On full page load
document.addEventListener('DOMContentLoaded', function () {
  // Initialize all popups
  document.querySelectorAll('.newsletter-popup-overlay').forEach(function (popup) {
    var sectionId = popup.id.replace('newsletter-popup-', '');
    if (sectionId) {
      window.newsletterActions.initPopup(sectionId);
    }
  });

  // Handle post-submit success/error (after page reload)
  document.querySelectorAll('.newsletter-form').forEach(function (form) {
    var sectionId = form.dataset.sectionId;
    var successEl = form.querySelector('.newsletter-success');
    var errorEl = form.querySelector('.newsletter-error');

    if (successEl && successEl.textContent.trim() !== '' && successEl.textContent.trim() !== '&nbsp;') {
      var popupSubmitted = sectionId && sessionStorage.getItem('popup_submitted_' + sectionId) === 'true';
      if (popupSubmitted && !sessionStorage.getItem('popup_success_shown_' + sectionId)) {
        window.newsletterActions.showSuccessOnLoad(sectionId);
        try { sessionStorage.removeItem('popup_submitted_' + sectionId); } catch (e) { }
      }
    } else if (errorEl && errorEl.textContent.trim() !== '' && errorEl.textContent.trim() !== '&nbsp;') {
      var popupSubmittedErr = sectionId && sessionStorage.getItem('popup_submitted_' + sectionId) === 'true';
      if (popupSubmittedErr) {
        window.newsletterActions.showErrorOnLoad(sectionId);
        try { sessionStorage.removeItem('popup_submitted_' + sectionId); } catch (e) { }
      }
    }

    // Prevent invalid submission (fallback)
    var emailInput = form.querySelector('[name="contact[email]"]');
    if (emailInput) {
      form.addEventListener('submit', function (e) {
        var email = emailInput.value.trim();
        if (!window.newsletterActions.isValidEmail(email)) {
          e.preventDefault();
          window.newsletterActions.validateEmail(sectionId);
          emailInput.focus();
        }
      });
    }
  });
});